module.exports = __webpack_public_path__ + "img/success_OLD_b.04b0b714.gif";